























































import Vue, { PropType } from "vue";
import Icon from "@/components/Icon.vue";
import { SIZE, TYPE, useGenAiPalette } from "../data/design";

export interface BarSegment {
  key: string;
  value: number;
  color: string;
  /** hover text, e.g. "High: 3 activities" */
  title: string;
}

export default Vue.extend({
  components: { Icon },
  props: {
    icon: { type: String, required: true },
    name: { type: String, required: true },
    value: { type: Number, required: true },
    segments: { type: Array as PropType<BarSegment[]>, required: true },
    /** what a full-width bar stands for */
    max: { type: Number, required: true },
    label_width: { type: String, default: "" },
    /** the count's colour under the pointer; defaults to blue */
    hover_value: { type: String, default: "" },
    title: { type: String, default: "" },
    aria_label: { type: String, default: "" },
  },
  setup(props) {
    const width_of = (value: number) =>
      (100 * value) / Math.max(1, props.max as number) + "%";
    return { width_of, T: useGenAiPalette(), TY: TYPE, S: SIZE };
  },
});
